import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../shared/environments/environment';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { IProject, IProjectCreate, IProjectUpdate } from '../typing/project.interface';

@Injectable({
    providedIn: 'root'
})
export class ProjectService {

    constructor(private http: HttpClient) {
    }

    getList(query: Params = {}): Observable<IPaginatedResponse<IProject>> {
        return this.http.get<IPaginatedResponse<IProject>>(`${environment.API_BASE_PATH}/projects`, {params: query});
    }

    getProject(id: number): Observable<IProject> {
        return this.http.get<IProject>(`${environment.API_BASE_PATH}/project/${id}`);
    }

    createProject(project: IProjectCreate): Observable<IProject> {
        return this.http.post<IProject>(`${environment.API_BASE_PATH}/project`, project);
    }

    updateProject(project: IProjectUpdate): Observable<IProject> {
        return this.http.put<IProject>(`${environment.API_BASE_PATH}/project/${project.id}`, project);
    }

    deleteProjects(data: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/projects`, {
            body: data
        });
    }
}
